import * as React from 'react';
import { Icon } from '../icon/icon';

export const IconDividendsFilled: React.FC = () => (
    <Icon viewBox="0 0 24 24" fill="none">
        <g>
            <path
                d="M16.36,16.28c4,0,7.19-2.89,7.19-6.45,0-2.77-2.61-5.81-5.08-7a.24.24,0,0,1-.13-.15.27.27,0,0,1,0-.2L19.31.88A.56.56,0,0,0,18.83,0H14.08a.56.56,0,0,0-.48.85l1,1.57a.27.27,0,0,1,0,.2.24.24,0,0,1-.13.15c-2.53,1.2-5.27,4.25-5.27,7C9.17,13.39,12.39,16.28,16.36,16.28Zm-.42-6.5C14.94,9.1,14,8.46,14,7.53A1.41,1.41,0,0,1,15.55,6s.06,0,.06-.07V5.5a.75.75,0,0,1,1.5,0v.22a.26.26,0,0,0,.25.25H18a.75.75,0,0,1,0,1.5H15.52a0,0,0,0,0,0,0,.19.19,0,0,0,0,.07,7.8,7.8,0,0,0,1.27,1c1,.68,2,1.32,2,2.25a1.45,1.45,0,0,1-1.56,1.56.07.07,0,0,0-.07.06v.41a.75.75,0,1,1-1.5,0v-.22a.25.25,0,0,0-.25-.25h-.62a.75.75,0,1,1,0-1.5h2.47a0,0,0,0,0,0,0,.14.14,0,0,0,0-.07A8,8,0,0,0,15.94,9.78Z"
                fill="currentColor"
            />
            <path
                d="M20.44,18,16.92,19.2a.23.23,0,0,0-.15.14A2,2,0,0,1,15,20.53H11a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h4a1,1,0,1,0,0-2h-3.5c-.31,0-1.51-1.5-4-1.5H5.39a4,4,0,0,0-1.79.42L.58,18a.25.25,0,0,0-.13.22v5.4a.27.27,0,0,0,.12.22.27.27,0,0,0,.26,0l3.22-2a1,1,0,0,1,.85-.1c10,3.36,6.63,3.37,17.87-2.31a.51.51,0,0,0,.1-.85A2.49,2.49,0,0,0,20.44,18Z"
                fill="currentColor"
            />
        </g>
    </Icon>
);
